<template>
    <div class="pb-2 pt-2">
        <vx-tooltip :text="tooltipText">
            <vs-chip :color="color">{{ responsible }}</vs-chip>
        </vx-tooltip>
    </div>
</template>

<script>
    export default {
        data: () => ({
            drawer: true,
            drawerRight: true,
            right: null,
            left: null
        }),
        props: {
            responsible: String,
            type: String
        },
        computed: {
            color() {
                if (this.type === 'origination') return 'blue';
                if (this.type === 'credit_risk') return 'red';
                return 'grey';
            },
            tooltipText() {
                if (this.type === 'origination') return 'Ejecutivo de originación';
                if (this.type === 'credit_risk') return 'Analista de riesgo crediticio';
                return 'Responsible';
            }
        }
    }
</script>